import React from 'react';
import { Typography, withStyles } from 'material-ui';
import classNames from 'classnames';
import AlertIcon from 'material-ui-icons/Error';
import CloseIcon from 'material-ui-icons/Cancel';
import { DoRender } from '../components/Utils/shared';

const styles = theme => ({
    textColor: {
        color: theme.palette.primary.contrastText
    },
    alertIcon: {
        color: theme.palette.primary.contrastText,
        transform: 'scale(1.6)',
        float: 'left',
        marginRight: '16px',
    },
    warning: {
        backgroundColor: theme.palette.background.warning
    },
    info: {
        backgroundColor: theme.palette.background.info
    },
    error: {
        backgroundColor: theme.palette.background.error
    },
    success: {
        backgroundColor: theme.palette.background.success
    }
});

/**
 * Componente para mostrar feedback de error o exito.
 */
class InformationPanel extends React.Component {

    constructor(props) {
        super(props);
        props = {
            type: 'error'
        };
    }

    render() {
        const { classes, onCancel, hideIcon } = this.props;
        const type = this.props.type.toLowerCase();
        const panelClass = classes[type];

        return (
            <div className={classNames(panelClass, 'InformationPanel')}>
                {onCancel ?
                    <CloseIcon className='closeIconComponent' style={{
                        float: 'right', color: 'var(--primary-text-color)'
                    }} onClick={(e) => {
                        if (onCancel) {
                            onCancel(this);
                        }
                    }} />
                    : ''}
                <div className="cmsContainer">

                    <DoRender if={!hideIcon}>
                        {this.props.icon ? this.props.icon : <AlertIcon className={classes.alertIcon} />}
                    </DoRender>
                    
                    <Typography variant={'headline'}
                        className={classes.textColor}>{this.props.title}
                    </Typography>
                    {
                        this.props.text ?
                            <div>
                                <Typography variant={'body1'}
                                    className={classes.textColor}>
                                    {this.props.text}
                                </Typography></div> : ''
                    }
                    {this.props.children}
                </div>
            </div>
        );
    }
}
export default withStyles(styles)(InformationPanel);



// WEBPACK FOOTER //
// ./src/ui/InformationPanel.js